import { createTheme } from '@mui/material';

import { black } from '~/styles/colors';
import OutlinedInput from '~/theme/MuiComponentOverrides/OutlinedInput';

import breakpoints from './theme/breakpoints';
import Alert from './theme/MuiComponentOverrides/Alert';
import Breadcrumbs from './theme/MuiComponentOverrides/Breadcrumbs';
import Button from './theme/MuiComponentOverrides/Button';
import Chip from './theme/MuiComponentOverrides/Chip';
import CSSBaseline from './theme/MuiComponentOverrides/CSSBaseline';
import DataGrid from './theme/MuiComponentOverrides/DataGrid';
import Dialog from './theme/MuiComponentOverrides/Dialog';
import DialogContent from './theme/MuiComponentOverrides/DialogContent';
import DialogTitle from './theme/MuiComponentOverrides/DialogTitle';
import FormControl from './theme/MuiComponentOverrides/FormControl';
import InputLabel from './theme/MuiComponentOverrides/InputLabel';
import Link from './theme/MuiComponentOverrides/Link';
import ListItemButton from './theme/MuiComponentOverrides/ListItemButton';
import MenuItem from './theme/MuiComponentOverrides/MenuItem';
import Select from './theme/MuiComponentOverrides/Select';
import Snackbar from './theme/MuiComponentOverrides/Snackbar';
import Tabs from './theme/MuiComponentOverrides/Tabs';
import Switch from './theme/MuiComponentOverrides/Switch';
import Typography from './theme/MuiComponentOverrides/Typography';
import palette from './theme/palette';
import typography from './theme/typography';

export const drawerWidth = 280;

export const navConstants = {
  drawerWidth: 280,
  collapsedDrawerWidth: 56,
  transitionDuration: 250,
  enteringDelay: 200,
  exitingDelay: 125,
};

// Create a theme instance.
export const borderColor = black[200];

const theme = createTheme({
  ...breakpoints,
  ...palette,
  ...typography,
  components: {
    ...Button,
    ...CSSBaseline,
    ...DataGrid,
    ...Tabs,
    ...Breadcrumbs,
    ...Typography,
    ...Link,
    ...Dialog,
    ...DialogContent,
    ...DialogTitle,
    ...Alert,
    ...Chip,
    ...Select,
    ...Snackbar,
    ...MenuItem,
    ...OutlinedInput,
    ...InputLabel,
    ...FormControl,
    ...Switch,
    MuiDivider: {
      styleOverrides: {
        root: {
          borderColor,
        },
      },
    },
    MuiDrawer: {
      styleOverrides: {
        paperAnchorDockedLeft: {
          borderRight: `0px solid ${borderColor}`,
        },
      },
    },
    ...ListItemButton,
  },
});

export default theme;
